import { useEffect, useState, useRef, useCallback } from "react";
import "./UniversityDashboardLayout.scss";
import activitiesIcon from "../../Assets/Activities/activitiesIcon.svg";
import search from "../../Assets/Tutor/searchIconGray.svg";
import universityIcon from "../../Assets/University/universityIcon.svg";
import schoolIocn from "../../Assets/School/schoolIocn.svg";
import TutorImg from "../../Assets/Tutor/TutorImg.svg";
import themeParkIcon from "../../Assets/SideBar/themeParkActive.svg";
import { useNavigate } from "react-router-dom";
import React from 'react';
import {
  API_END_POINTS,
  AUTHENTICATION,
  FILTER_CONSTANT,
  GLOBAL_CONSTANTS,
  ROUTES,
} from "../../Constants/Constants";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { store } from "../../Redux/Store/Store";
import { setLoader, setLoginSignUpOpen, setUniversityFilter } from "../../Redux/Reducer/Reducer";
import {
  GetSessionStorageData,
  encryptPassData,
  SetSessionStorageData,
  isObjectEmptyValue,
  nullUndefinedEmptyCheck,
} from "../../Utilities/Helpers/Helper";
import ExpandMap from "../../Assets/Activities/ExpandMap.svg";
import UniversityMaps from "../../Components/UniversityMaps/UniversityMaps";
import universityImg from "../../Assets/University/universityImg.png";
import UniversityLikeIcon from "../../Assets/University/UniversityLikeIcon.svg";
import universityShareIcon from "../../Assets/University/universityShareIcon.svg";
import locationIcon from "../../Assets/Tutor/location.svg";
import toast from "react-hot-toast";
import UniversityFill from "../../Assets/HeartFill/UniversityFill.svg";
import { useDispatch, useSelector } from "react-redux";
import WebShareComponent from "../../Components/WebShare/WebShare";
import AppFilter from "../../Components/AppFilter.tsx/AppFilter";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { useMediaQuery, useTheme } from "@mui/material";


interface University {
  id: number;
  university_name?: string;
  arabic_university_name?: string;
  QS_ranking?: number | null;
  THE_ranking?: number | null;
  SH_ranking?: number | null;
  least_price?: number;
  images?: string;
  city?: string;
  address?: string;
  is_favourite?: boolean;
}

const UniversityDashboardLayout = () => {
  const { t } = useTranslation();
  const University_search = GetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.UNIVERSITY);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState(University_search ? University_search : "");
  const [UniversityList, setUniversityList] = useState<University[]>([]);
  const [list, setList] = useState<University[]>([]);
  const [searchTextList, setSearchTextList] = useState([]);
  const [currentLat, setCurrentLat] = useState<any>("");
  const [currentLang, setCurrentLang] = useState<any>("");
  const [IsTrigger, setIsTrigger] = useState<any>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768));
  const limit = 10;
  const [totalPages, setTotalPages] = useState<number>(1);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const mapDebounceRef = useRef<any>(null);
  const containerStyle: React.CSSProperties = isMobile
    ? {
      width: "100%",
      minHeight: "200px",
      maxHeight: "400px",
      height: "40vh",
    }
    : {
      width: "100%",
      minHeight: "235px",
      maxHeight: "800px",
      height: "100vh",
    };

  // get google map loaded flag from redux
  const isLoaded: boolean = useSelector((state: any) => state.googleMapLoadedReducer?.isGoogleMapLoaded);

  const handleUniversityMapLocationChange = (newLat: number | string, newLng: number | string) => {
    console.log("Received newLat:", newLat, "newLng:", newLng); // Debug log
    const lat = typeof newLat === "string" ? parseFloat(newLat) : newLat;
    const lng = typeof newLng === "string" ? parseFloat(newLng) : newLng;

    if (isNaN(lat) || isNaN(lng)) {
      console.error("Invalid coordinates:", { lat, lng });
      toast.error(t("Invalid location selected"));
      return;
    }

    // Update UI immediately
    setCurrentLat(lat);
    setCurrentLang(lng);

    // Debounce API call
    if (mapDebounceRef.current) clearTimeout(mapDebounceRef.current);
    mapDebounceRef.current = setTimeout(() => {
      const filterToUse = getUniversityFilter && isObjectEmptyValue(getUniversityFilter) ? getUniversityFilter : FilterApplyData;
      console.log("Calling UniversityListApi with:", { lat, lng, searchValue, filterToUse }); // Debug log
      UniversityListApi(lat, lng, searchValue, filterToUse, true);
    }, 600);
  };

  const getUniversityFilter: any = useSelector((state: any) => {
    return state.filterReducer?.universityfilter;
  });

  const init_Universityfilter: any = useSelector((state: any) => {
    return state.initFilterReducer.initUniversityfilter;
  });

  const init_filter = {
    programs: [],
    price: [0, 0],
    qs_ranking: [0, 0],
    the_ranking: [0, 0],
    sh_ranking: [0, 0],
    language_instruction: [],
    radius: 30,
  };

  const [FilterPopOpen, setFilterPopOpen] = useState(false);
  const [FilterData, setFilterData] = useState<any>([]);
  const [initFilter, setInitFilter] = useState<any>(
    isObjectEmptyValue(init_Universityfilter) ? init_Universityfilter : init_filter
  );
  const [FilterApplyData, setFilterApplyData] = useState<any>(init_filter);
  const [radius, setRadius] = useState(init_filter.radius);
  const [initSort, setSort] = useState<any>({
    price: "",
    rating: "",
    the_rating: "",
    sh_rating: "",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onOpenFilterPop = () => {
    setFilterPopOpen(true);
  };

  const onCloseFilterPop = () => {
    setFilterPopOpen(false);
  };

  // Memoize scroll handler with useCallback
  const handleScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container || isLoading || page >= totalPages) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    const distanceToBottom = scrollHeight - (scrollTop + clientHeight);

    // Trigger when user is within 150px of bottom
    if (distanceToBottom < 150) {
      setPage((prevPage) => {
        const nextPage = prevPage + 1;
        
        console.log(`[Scroll] Loading page ${nextPage} of ${totalPages}`);
        
        if (nextPage <= totalPages) {
          UniversityListApi(
            currentLat,
            currentLang,
            searchValue,
            FilterApplyData,
            false,
            nextPage,
            limit
          );
        }

        return nextPage;
      });
    }
  }, [
    page,
    totalPages,
    isLoading,
    currentLat,
    currentLang,
    searchValue,
    FilterApplyData,
    limit,
  ]);


  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const handleRouteMap = () => {
    navigate(ROUTES.UNIVERSITY_MAPS_VIEW, {
      state: {
        University_list: UniversityList,
        search_text: searchValue,
        redius: FilterApplyData.radius,
        lat: currentLat,
        lang: currentLang,
        filter: FilterApplyData,
        filterBoolean: IsTrigger,
      },
    });
  };

  const navigateUniversityDetailedView = (value: any) => {
    navigate(ROUTES.UNIVERSITY_DETAILE_VIEW + "?id=" + encryptPassData(value?.id), {
      state: { tutor_Detailes: value },
    });
  };

  const HeaderLoction: any = useSelector((state: any) => {
    return state.locationReducer.location;
  });

  useEffect(() => {
    if (nullUndefinedEmptyCheck(HeaderLoction?.lat && HeaderLoction?.lng)) {
      setCurrentLat(HeaderLoction?.lat);
      setCurrentLang(HeaderLoction?.lng);
      if (getUniversityFilter && isObjectEmptyValue(getUniversityFilter)) {
        UniversityListApi(HeaderLoction?.lat, HeaderLoction?.lng, searchValue, getUniversityFilter, true);
      } else {
        UniversityListApi(HeaderLoction?.lat, HeaderLoction?.lng, searchValue, FilterApplyData, true);
      }
    }
  }, [HeaderLoction, FilterApplyData]);

  useEffect(() => {
    getFilterData();
  }, []);

  const payload = (latitude: any, longitude: any, value: string, filter: any, page: number, limit: number) => {
    var qsValue: any = [];
    var shValue: any = [];
    var theValue: any = [];
    var priceValue: any = [];

    if (initFilter.price[0] === filter.price[0] && initFilter.price[1] === filter.price[1]) {
      priceValue = [];
    } else if (initFilter.price[0] == 0 && initFilter.price[1] == 0) {
      priceValue = [];
    } else {
      priceValue = {
        min: filter.price[0],
        max: filter.price[1],
      };
    }

    if (initFilter.qs_ranking[0] === filter.qs_ranking[0] && initFilter.qs_ranking[1] === filter.qs_ranking[1]) {
      qsValue = [];
    } else if (initFilter.qs_ranking[0] == 0 && initFilter.qs_ranking[1] == 0) {
      qsValue = [];
    } else {
      qsValue = {
        min: filter.qs_ranking[0],
        max: filter.qs_ranking[1],
      };
    }

    if (initFilter.sh_ranking[0] === filter.sh_ranking[0] && initFilter.sh_ranking[1] === filter.sh_ranking[1]) {
      shValue = [];
    } else if (initFilter.sh_ranking[0] == 0 && initFilter.sh_ranking[1] == 0) {
      shValue = [];
    } else {
      shValue = {
        min: filter.sh_ranking[0],
        max: filter.sh_ranking[1],
      };
    }

    if (initFilter.the_ranking[0] === filter.the_ranking[0] && initFilter.the_ranking[1] === filter.the_ranking[1]) {
      theValue = [];
    } else if (initFilter.the_ranking[0] == 0 && initFilter.the_ranking[1] == 0) {
      theValue = [];
    } else {
      theValue = {
        min: filter.the_ranking[0],
        max: filter.the_ranking[1],
      };
    }

    return {
      latitude: latitude?.toString(),
      longitude: longitude?.toString(),
      radius: filter.radius,
      search: value ? value : "",
      price: priceValue,
      qs_ranking: qsValue,
      sh_ranking: shValue,
      the_ranking: theValue,
      programs: filter.programs,
      language_instruction: filter.language_instruction,
      page: page,
      limit: limit,
    };
  };
  const UniversityListApi = (
    latitude: any,
    longitude: any,
    value: string,
    filter: any,
    initialLoad: boolean = false,
    pageParam: number = 1,
    limitParam: number = limit
  ) => {
    if (isLoading) return;

    setIsLoading(true);

    const pay = payload(
      latitude,
      longitude,
      value,
      filter,
      pageParam,
      limitParam
    );

    const headerLang =
      language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "en" : "ar";

    axiosInstance
      .post(`${API_END_POINTS.UNIVERSITYLIST}`, pay, {
        headers: { "Accept-Language": headerLang },
      })
      .then((response: any) => {
        const newData = response?.data?.result?.data || [];
        const totalPageCount = response?.data?.result?.total_page || 1;
        
        console.log(`[API Response] Received ${newData.length} items, total_page=${totalPageCount}`);
        
        setTotalPages(totalPageCount);

        // ✅ Initial load / radius / filter change
        if (initialLoad) {
          setUniversityList(newData);
          setList(newData);
          setPage(1);
          setInitialLoadComplete(true);
          console.log(`[API] Initial load: Set page=1, totalPages=${totalPageCount}`);
          return;
        }

        // ✅ Merge new data for pagination
        setUniversityList((prev) => {
          const merged = [...prev, ...newData];
          console.log(`[API] Merged data: previous=${prev.length}, new=${newData.length}, total=${merged.length}`);

          // apply sorting AFTER merge
          if (
            initSort?.price ||
            initSort?.rating ||
            initSort?.the_rating ||
            initSort?.sh_rating
          ) {
            handleProceedSort(
              initSort?.price,
              initSort?.rating,
              initSort?.the_rating,
              initSort?.sh_rating,
              merged
            );
          }

          return merged;
        });

        setList((prev) => [...prev, ...newData]);
        
        console.log(`[API] Page loaded successfully. Current page will be updated by scroll handler.`);
      })
      .catch((error) => {
        console.error("Error fetching universities:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };



  const searchUniversityKeyword = (search: any) => {
    var payload = {
      search_text: search,
      latitude: `${currentLat}`,
      longitude: `${currentLang}`,
      radius: radius,
    };
    const headerLang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "en" : "ar";
    axiosInstance
      .post(`${API_END_POINTS.UNIVERSITY_KEY_WORD_SEARCH}`, payload, { headers: { "Accept-Language": headerLang } })
      .then((response: any) => {
        setSearchTextList(response?.data.result?.data);
      })
      .catch(() => { });
  };

  const getFilterData = () => {
    const headerLang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "en" : "ar";
    axiosInstance
      .get(`${API_END_POINTS.UNIVERSITYFILTERLIST}`, { headers: { "Accept-Language": headerLang } })
      .then((response: any) => {
        if (response?.data?.status) {
          let data = response?.data?.result?.data;
          setFilterData(data);
          if (data) {
            let init = {
              programs: [],
              price: [data.price?.min, data.price?.max],
              qs_ranking: [data.qs_ranking?.min, data.qs_ranking?.max],
              the_ranking: [data.the_ranking?.min, data.the_ranking?.max],
              sh_ranking: [data.sh_ranking?.min, data.sh_ranking?.max],
              language_instruction: [],
              radius: 30,
            };
            setInitFilter(init);
            SetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.UNIVERSITY, JSON.stringify(init));
            if (getUniversityFilter && isObjectEmptyValue(getUniversityFilter)) {
              setFilterApplyData(getUniversityFilter);
              setRadius(getUniversityFilter.radius);
            } else {
              setFilterApplyData(init);
            }
          }
        }
      })
      .catch(() => { });
  };
  const FilterApply = (filter: any) => {
    setIsTrigger(true);
    setInitialLoadComplete(false); // ✅ important

    setPage(1);
    setTotalPages(1);
    setUniversityList([]);
    setList([]);

    store.dispatch(setUniversityFilter(filter));
    setFilterApplyData(filter);
    setRadius(filter.radius);

    UniversityListApi(currentLat, currentLang, searchValue, filter, true);
  };



  const onInputChange = (value: any) => {
    store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.UNIVERSITY, value);
      if (value?.length > 2) {
        searchUniversityKeyword(value);
      }
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    UniversityListApi(currentLat, currentLang, searchValue, FilterApplyData, true);
  };

  const handleChangeFavourites = (val: any, id: any) => {
    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    if (nullUndefinedEmptyCheck(accessToken)) {
      var payload = {
        service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.FIVE_INT,
        service_provider: id,
        is_favourite: !val,
      };
      const headerLang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "en" : "ar";
      axiosInstance
        .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload, { headers: { "Accept-Language": headerLang } })
        .then((response: any) => {
          if (response?.data?.status) {
            UniversityListApi(currentLat, currentLang, searchValue, FilterApplyData);
            toast.success(response?.data?.message, {
              position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
            });
          }
        })
        .catch((error) => {
          console.log(" handleChangeFavourites - error:", error);
        });
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };

  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  const Ssearch_Button = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "ssearch_button_english" : "ssearch_button_arab";
  const RowOverRideSchool = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "row-override-school" : "row-override-school_arab";

  const handlePassListPage = (value: any) => {
    if (nullUndefinedEmptyCheck(value)) {
      if (value?.includes("near me")) {
        navigate(ROUTES.UNIVERSITY_LIST_VIEW, {
          state: {
            University_list: UniversityList,
            search_text: value,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLang,
            map_show: true,
            filter: FilterApplyData,
            filterBoolean: IsTrigger,
          },
        });
      } else {
        navigate(ROUTES.UNIVERSITY_LIST_VIEW, {
          state: {
            University_list: UniversityList,
            search_text: value,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLang,
            map_show: false,
            filter: FilterApplyData,
            filterBoolean: IsTrigger,
          },
        });
      }
    } else {
      UniversityListApi(currentLat, currentLang, value, FilterApplyData, true);
    }
  };

  const sort: any = GetSessionStorageData("sort");
  useEffect(() => {
    let data = JSON.parse(sort);
    if (data?.price || data?.rating || data?.the_rating || data?.sh_rating) {
      handleProceedSort(data?.price, data?.rating, data?.the_rating, data?.sh_rating);
    }
  }, [sort]);

  const handleProceedSort = (checkedPrice: any, checkedRating: any, theRating: any = "", shRating: any = "", data: any = null) => {
    const sortedData = data ? [...data] : [...list];

    if (checkedPrice == "high") {
      sortedData.sort((a: any, b: any) => b?.least_price - a?.least_price);
    } else if (checkedPrice == "low") {
      sortedData.sort((a: any, b: any) => a?.least_price - b?.least_price);
    } else if (checkedRating == "high") {
      sortedData.sort((a: any, b: any) => {
        if (a?.QS_ranking == null) return 1;
        if (b?.QS_ranking == null) return -1;
        return a.QS_ranking - b.QS_ranking;
      });
    } else if (checkedRating == "low") {
      sortedData.sort((a: any, b: any) => {
        if (a?.QS_ranking == null) return 1;
        if (b?.QS_ranking == null) return -1;
        return b.QS_ranking - a.QS_ranking;
      });
    } else if (theRating === "high") {
      sortedData.sort((a: any, b: any) => {
        if (a?.THE_ranking == null) return 1;
        if (b?.THE_ranking == null) return -1;
        return a.THE_ranking - b.THE_ranking;
      });
    } else if (theRating === "low") {
      sortedData.sort((a: any, b: any) => {
        if (a?.THE_ranking == null) return 1;
        if (b?.THE_ranking == null) return -1;
        return b.THE_ranking - a.THE_ranking;
      });
    } else if (shRating === "high") {
      sortedData.sort((a: any, b: any) => {
        if (a?.SH_ranking == null) return 1;
        if (b?.SH_ranking == null) return -1;
        return a.SH_ranking - b.SH_ranking;
      });
    } else if (shRating === "low") {
      sortedData.sort((a: any, b: any) => {
        if (a?.SH_ranking == null) return 1;
        if (b?.SH_ranking == null) return -1;
        return b.SH_ranking - a.SH_ranking;
      });
    }

    setUniversityList(sortedData);
    setSort({
      price: checkedPrice,
      rating: checkedRating,
      the_rating: theRating,
      sh_rating: shRating,
    });
  };

  const handleNavigate = (route: string, routeName: string) => {
    console.log(`Navigating to ${routeName} with route: ${route}`);
    navigate(route);
  };

  return (
    <div className="University__dashboard__container">
      <div className="row">
        <div className="col-12 title_container">
          {
            !isMobile && <div className="Dashboard__UniversityCard_Img_wapper">
              <img draggable="false" src={universityIcon} alt="TutorImg" />
              <div className="text">{t("Universities")}</div>
            </div>
          }

          {isMobile && (
            <Swiper
              slidesPerView="auto"
              spaceBetween={10}
              navigation={false}
              scrollbar={{ draggable: false }}
              modules={[Navigation, Scrollbar]}
              className="nav-swiper"
              style={{ overflow: "hidden" }}
            >
              <SwiperSlide style={{ width: "auto" }}>
                <div
                  className="Dashboard__UniversityCard_Img_wapper"
                >
                  <img draggable="false" src={universityIcon} alt="TutorImg" width={24} height={24} />
                  <div className="text">{t("Universities")}</div>
                </div>
              </SwiperSlide>
              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="nav-button gap-2"
                  onClick={() => handleNavigate(ROUTES.SCHOOLLAYOUT, "Schools")}
                  title={t("Schools")}
                >
                  <img draggable="false" src={schoolIocn} alt="Schools" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px' }}>{t("Schools")}</span>
                </button>
              </SwiperSlide>
              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="nav-button gap-2"
                  onClick={() => handleNavigate(ROUTES.TUTORS, "Tutors")}
                  title={t("Tutors")}
                >
                  <img draggable="false" src={TutorImg} alt="TutorImg" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px' }}>{t("Tutors")}</span>
                </button>
              </SwiperSlide>

              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="nav-button gap-2"
                  onClick={() => handleNavigate(ROUTES.ACTIVITYLAYOUT, "Activities")}
                  title={t("Activities")}
                >
                  <img draggable="false" src={activitiesIcon} alt="Activities" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px' }}>{t("Activities")}</span>
                </button>
              </SwiperSlide>

              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="nav-button gap-2"
                  onClick={() => handleNavigate(ROUTES.THEMEPARK__HOMEPAGE, "Parks & Events")}
                  title={t("Parks & Events")}
                >
                  <img draggable="false" src={themeParkIcon} alt="ParksAndEventIcon" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px' }}>{t("Parks & Events")}</span>
                </button>
              </SwiperSlide>
            </Swiper>
          )}
        </div>

        <div className={`row mb-2 ${RowOverRideSchool}`}>
          <div className="col-lg-3 col-md-12 input-style-phone">
            <div className="search_field_wrapper">
              <div className="search__autocomplete">
                <form onSubmit={handleSubmit}>
                  <Autocomplete
                    freeSolo
                    popupIcon
                    id="free-solo-2-demo"
                    disableClearable={false}
                    value={searchValue}
                    clearIcon={false}
                    onChange={(e, value) => {
                      const trimedvalue = value ? value.trim() : "";
                      setSearchValue(trimedvalue);
                      handlePassListPage(trimedvalue);
                      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.UNIVERSITY, trimedvalue);
                    }}
                    options={searchTextList?.map((option: any) =>
                      language === "English"
                        ? option?.university_name
                        : option?.arabic_university_name || option?.university_name
                    )}
                    renderOption={(props, option) => (
                      <Box component="li" sx={[{ px: 0.5, py: 0.7 }]} {...props} className="notranslate" translate="no">
                        {option}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={t("Search for University")}
                        onChange={(inputChangeEvent: any) => {
                          onInputChange(inputChangeEvent.target.value.trim());
                        }}
                        onKeyDown={(e: any) => {
                          if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.ENTER) {
                            e.preventDefault();
                            const trimedvalue = searchValue.trim();
                            if (trimedvalue) {
                              handlePassListPage(trimedvalue);
                            }
                          }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          type: "text",
                        }}
                      />
                    )}
                  />
                  <img
                    draggable="false"
                    src={search}
                    alt="search"
                    className={`${Ssearch_Button} search_button`}
                    onClick={() => handlePassListPage(searchValue)}
                  />
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-12">
            <AppFilter
              FilterPopOpen={FilterPopOpen}
              onOpenPop={onOpenFilterPop}
              onClosePop={onCloseFilterPop}
              FilterData={FilterData}
              FilterApply={FilterApply}
              FilterApplyData={FilterApplyData}
              initFilter={initFilter}
              initSort={initSort}
              handleApplySort={handleProceedSort}
              type="university"
              color="#12CC92"
            />
          </div>
        </div>

        <div className="body_scroll_container" style={{ height: '800px' }}>
          <div className="map_container">
            <div className="University_map_view">
              <div className="University__viewMap" onClick={handleRouteMap}>
                <img src={ExpandMap} alt="ExpandMap" />
                <span>{t("View on Map")}</span>
              </div>
              <UniversityMaps
                zoom={12}
                radius={FilterApplyData.radius * 1000}
                lat={currentLat}
                lang={currentLang}
                containerStyle={containerStyle}
                disable={true}
                zoomControl={false}
                clickableIcons={false}
                draggable={false}
                UniversityList={UniversityList}
                initSort={initSort}
                getOneTutor={() => { }} // no-op to satisfy prop type
                filter={isObjectEmptyValue(getUniversityFilter) ? getUniversityFilter : FilterApplyData}
                initFilter={initFilter}
                searchValue={searchValue}
                language={language}
                isLoaded={isLoaded}
                onLocationChange={handleUniversityMapLocationChange} // enabled and debounced
              />
            </div>
          </div>
          <div className="university__list__container" ref={scrollContainerRef}>
            {UniversityList?.map((item: any) => (
              <div
                className="university__list__wapper"
                key={item.id}
                onClick={() => navigateUniversityDetailedView(item)}
              >
                <div className="university__leftside">
                  <img
                    src={nullUndefinedEmptyCheck(item?.images) ? item?.images : universityImg}
                    alt=""
                    onError={(e: any) => {
                      e.target.src = universityImg;
                    }}
                  />
                </div>
                <div className="university__rightside">
                  <div className="university__name">
                    <span className="notranslate name" translate="no">
                      {language === "English"
                        ? item?.university_name
                        : item?.arabic_university_name || item?.university_name}
                    </span>
                    <div className="imageIcon" onClick={(e) => e.stopPropagation()}>
                      <WebShareComponent
                        params={ROUTES.UNIVERSITY_DETAILE_VIEW + "?id=" + encryptPassData(item?.id)}
                      >
                        <img src={universityShareIcon} alt="" className="mb-1" />
                      </WebShareComponent>
                      <img
                        src={item?.is_favourite ? UniversityFill : UniversityLikeIcon}
                        alt=""
                        onClick={() => handleChangeFavourites(item.is_favourite, item?.user)}
                      />
                    </div>
                  </div>

                  <div className="university__location">
                    <img src={locationIcon} alt="" />
                    <span
                      className="location"
                      title={nullUndefinedEmptyCheck(item?.city) ? item?.city : item.address}
                    >
                      {nullUndefinedEmptyCheck(item?.city) ? item?.city : item.address}
                    </span>
                  </div>

                  <div className="row">
                    <div className="col-xxl-4 col-lg-4 col-md-4 universiyt_item">
                      <div className="text__black">{t("QS")} :</div>
                      <div className="text__green">
                        {item?.QS_ranking ? item?.QS_ranking : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                      </div>
                    </div>
                    <div className="col-xxl-4 col-lg-4 col-md-4 universiyt_item">
                      <div className="text__black">{t("THE")} :</div>
                      <div className="text__green">
                        {item?.THE_ranking ? item?.THE_ranking : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                      </div>
                    </div>
                    <div className="col-xxl-4 col-lg-4 col-md-4 universiyt_item">
                      <div className="text__black">{t("SH")} :</div>
                      <div className="text__green">
                        {item?.SH_ranking ? item?.SH_ranking : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-lg-6 col-md-6 marginTop university__ranking">
                      <div className="text__black">{t("No. of students")} :</div>
                      <div className="text__green">
                        {item?.students_count ? item?.students_count : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-lg-6 col-md-6 marginTop university__ranking">
                      <div className="text__black">{t("Mediums")} :</div>
                      <div className="text__green">
                        {item?.available_mediums === "Both"
                          ? t("Online & On-premises")
                          : item?.available_mediums}
                      </div>
                    </div>
                  </div>
                  <div className="university__rating">
                    <div className="year">
                      {t("Founded")} :{" "}
                      {item?.founded_year ? item?.founded_year : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {isLoading && (
              <div className="loading-message text-center my-4">
                <span>{t("Loading universities...")}</span>
              </div>
            )}

            {!hasMore && UniversityList.length > 0 && !isLoading && (
              <div className="end-message text-center my-4">
                <span>{t("You've reached the end of the list")}</span>
              </div>
            )}

            {UniversityList?.length === 0 && !isLoading && (
              <div className="No__data__contant text-center my-4">
                <div className="text">{t("No Data's in Univerities")}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniversityDashboardLayout;